// extracted by mini-css-extract-plugin
export default {"button":"Button_button__J7P6l","whiteBtn":"Button_whiteBtn__jZWBI","blackBtn":"Button_blackBtn__Bdo9Q"};